import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import PropertyList from "../components/PropertyList"

const PropertyListPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='All Properties' />

        <PropertyList />

      </MasterLayout>
    </>
  );
};

export default PropertyListPage;
